export enum PlatformWmsFragments {
    PickList = 'PickList',
    PickLocation = 'PickLocation',
}
